<main class="container-xl pb-3 pb-lg-5">

  <!-- Promotions Slide-->
  <div *ngIf="!user">
    <app-promo-slide></app-promo-slide>
  </div>

  <div *ngIf="user">
   <app-recent-games></app-recent-games>
   <app-favourite-games></app-favourite-games>
  </div>

  <div *ngIf="user || userhasTracker">
    <app-recommended-games></app-recommended-games>
  </div>

  <section>
    <!-- searchbar-->
    <app-searchbar (searchChange)="onSearchChange($event)"></app-searchbar>

    <div id="category-nav" class="my-4">
      <div class="overflow-auto" id="pills-tab">
        <ul class="nav nav-pills flex-nowrap bg-darkest rounded-pill d-flex">
          <li class="nav-item" role="presentation" *ngFor="let category of displayedCategories; let i = index">
            <button class="nav-link rounded-pill d-flex flex-row text-nowrap py-2" [class.active]="i == 0" [ngClass]="{'ms-1': i !== 0}"
                    [id]="'pills-' + category + '-tab'" data-bs-toggle="pill"
                    [attr.data-bs-target]="'#pills-'+ category" type="button" role="tab"
                    [attr.aria-controls]="'pills-'+ category" aria-selected="false" (click)="loadItems()" >
              <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="category"></app-svg-icon>
              <span>{{"CATEGORIES." + (category | uppercase) | translate}}</span>
            </button>
          </li>
        </ul>
      </div>

      <!-- games-->
      <div class="tab-content" id="pills-tabContent">
        <ng-container *ngFor="let category of displayedCategories; let i = index">
          <div class="tab-pane fade show" [class.active]="i == 0"
               [id]="'pills-' + category" role="tabpanel" [attr.aria-labelledby]="'pills-' + category + '-tab'" tabindex="0">
            <div *ngIf="filteredGamesByCategory[i] && filteredGamesByCategory[i].length; else noGameBlock " class="pt-4">
              <app-game-chunk [games]="gamesToDisplayByCategory[i]" ></app-game-chunk>

              <div class="text-center" *ngIf="category !== 'all'; else moreAll">
                <a *ngIf="filteredGamesByCategory[i].length" class="btn btn-outline-secondary rounded-pill mx-2" routerLink="/games/{{category}}">
                 {{'HOME.ALL_LINK' | translate }} {{ filteredGamesByCategory[i].length }} {{ ('CATEGORIES.' + category.toUpperCase()) | translate }}
                </a>
              </div>

              <ng-template #moreAll>
                <app-item-showcase [totalItems]="filteredGamesByCategory[i].length" [itemsPerPage]="itemsPerPage" (itemsToLoad)="loadMore($event)"></app-item-showcase>
              </ng-template>

            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </section>

  <ng-template #noGameBlock>
    <div class="container text-center pt-5">
      <ng-container *ngIf="!games?.length">
        <h3>{{'HOME.NOGAMES_MESSAGE' | translate}}</h3>
        <h4>{{'HOME.NOGAMES_TIP' | translate}}</h4>
      </ng-container>
      <ng-container *ngIf="games?.length">
        <h3>{{'HOME.NOMATCH_MESSAGE' | translate}}</h3>
        <h4 *ngIf="searchTerm">{{'HOME.NOMATCH_TIP' | translate}}</h4>
      </ng-container>
    </div>
  </ng-template>


  <div class="mt-4">
    <app-providers-carousel></app-providers-carousel>

    <div *ngIf="games?.length">
      <app-carousel *ngFor="let category of randomGamesByCategoryForCarousels; let i = index;" [dataList]="category" [identifier]="categories[i]"></app-carousel>
    </div>
  </div>

</main>






